import Dia from './Dia'
//import Carousal from "@itseasy21/react-elastic-carousel";

import Carousel, { consts }  from 'react-elastic-carousel'
import Item from './Item'
import MiTime from "./MiTime"
import { useState } from 'react'


function Htmldia({ copyright, locality, day1, day2, day3, day4, day5, day6, day7 }) {
    //const meses = new Array('-', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');
   // const [actuliza, setActuliza] = useState(new Date())
    return (
        <>
        <style>
            {`
                .rec-slider-container {
                    margin: 0;
                }
            `}
        </style>
            <div className="header"><h3>El tiempo en {locality.name}</h3>
            <p>Pronóstico 7 días | {copyright}<br/><MiTime/></p></div>
            <Carousel isRTL={false} itemPosition={consts.START} outerSpacing={0}  pagination={false} showArrows={false} itemsToScroll={1} breakPoints={[
        { width: 2, itemsToShow: 2 },
        { width: 320, itemsToShow: 2 , itemsToScroll: 2},
        { width: 400, itemsToShow: 2 , itemsToScroll: 2},
        { width: 550, itemsToShow: 3 , itemsToScroll: 3},
        { width: 700, itemsToShow: 4 , itemsToScroll: 4},
        { width: 1000, itemsToShow: 5 , itemsToScroll: 5},
        { width: 1200, itemsToShow: 6 , itemsToScroll: 6},
        { width: 1750, itemsToShow: 8 , itemsToScroll: 8}
      ]} >
                <Item>
                    <Dia {...day1}/* meses={meses}*/ />
                </Item>
                <Item>
                    <Dia {...day2}/* meses={meses}*/ /></Item>
                <Item><Dia {...day3}/* meses={meses}*/ /></Item>
                <Item><Dia {...day4}/* meses={meses}*/ /></Item>
                <Item><Dia {...day5}/* meses={meses}*/ /></Item>
                <Item><Dia {...day6}/* meses={meses}*/ /></Item>
                <Item><Dia {...day7}/* meses={meses}*/ /></Item>
            </Carousel>
            <div><p className="linkTT"><a href={locality.url_weather_forecast_15_days} target="_blank"
                rel="nofollow">Predicción 15 días</a></p></div>
        </>
    )

}
export default Htmldia;